module.exports = __webpack_public_path__ + "img/strategy-tracer.78ca73c8.jpg";